var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.coupon)?_c('div',{staticClass:"coupon-section"},[(_vm.coupon)?_c('WizardForm',{attrs:{"coupon":_vm.coupon},on:{"coupon-changed":_vm.couponChanged}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }